import { RouteObject } from "react-router-dom";
import Landing from "./components/landing/landing";

export interface CriticalParametersRoute
  extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: CriticalParametersRoute[];
}

export const criticalParametersRoutes: CriticalParametersRoute[] = [
  {
    path: "/ax/settings/critical-parameters",
    element: <Landing />,
  },
];